<template>
  <fragment>
    <hero-header page-name="" hero-title="ourPartners"/>
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="mb-10">
          <div v-html="$t('pagePartners.intro')"></div>
        </v-col>
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-col cols="4" sm="3" md="2" v-for="(partner, index) in $store.state.generalStore.partners" :key="index">
              <logo :logo="partner" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import logo from '../components/logo.vue';

export default {
  name: 'partners',
  components: {
    heroHeader, logo,
  },
  data() {
    return {
      foo: 'bar',
    };
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
